import http from '@/services/http'

const getProcessResult = async (context, jobId) => {
  const response = await http.get(`/initial_load/job_status/`, {params: {job_id: jobId}})
  if (response != null) {
    return Promise.resolve(response.data)
  }
}

export default {
  getProcessResult
}



// WEBPACK FOOTER //
// ./src/features/initial_load/store/actions.js